import type { ColunasAntigasResponse, ConverterExcecaoDto, ConverterExcecaoResponse } from '@triade/contracts';
import { useConsulta, useMutacao } from './base';

/**
 * Sessao 51b (U8): colunas antigas do item (PIS/COFINS/ICMS/ISS) que nao entram no calculo da tabela estruturada.
 * GET /itens-tributos/colunas-antigas (item.ver + custo.ver) e POST /itens-tributos/converter-excecao (tributo.editar).
 */
export function useColunasAntigas(ativo: boolean = true) {
  return useConsulta<ColunasAntigasResponse>(['itens-tributos', 'colunas-antigas'], '/itens-tributos/colunas-antigas', { ativo });
}

export function useConverterExcecao() {
  return useMutacao<ConverterExcecaoResponse, ConverterExcecaoDto>({
    metodo: 'POST',
    caminho: () => '/itens-tributos/converter-excecao',
    corpo: (v) => v,
    // Itens (resumo/vigentes do item) e a lista de colunas antigas mudam com a conversao.
    invalidar: [['itens'], ['itens-tributos', 'colunas-antigas']],
  });
}
